import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import { PaneNav } from "src/domain/PaneNav/PaneNav";
import styled from "styled-components";
import { FontLoader } from "../../../components/FontLoader/FontLoader";
import { Navbar } from "../../../components/Navbar/Navbar";
import { Skeleton } from "../../../components/Skeleton/Skeleton";
import { color, spacing } from "../../../theme";
import { useLayout } from "../../../utils/hooks/useLayout";
import { useTypedLocation } from "../../../utils/hooks/useTypedLocation";
import { hashChange } from "../../../utils/location/hashChange";
import messages from "../RouteScreen.messages";

export function RouteScreenLoading() {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useTypedLocation();
  const layout = useLayout();
  const headerMargin = layout === "mobile" ? "0" : "16px 0 8px";

  function handleBackClick() {
    navigate(hashChange(undefined, location));
  }

  return (
    <LoadingWrapper>
      {layout === "mobile" && (
        <Navbar
          headingText={intl.formatMessage(messages.heading)}
          onBackClick={handleBackClick}
        />
      )}
      <Header>
        {layout !== "mobile" && <PaneNav onBackClick={handleBackClick} />}
        <Skeleton width="60%" height={24} margin={headerMargin} />
        <HeaderInner>
          <Skeleton width={50} height={16} padding="2px 0" />
          <Skeleton width={120} height={16} padding="2px 0" delay={0.15} />
        </HeaderInner>
      </Header>
      <LoadingTimelineItem />
      <LoadingTimelineItem />
      <Skeleton height={18} width="50%" margin="12px" />
      <Skeleton height={48} padding="0 12px" margin="12px 0" />
      <FontLoader />
    </LoadingWrapper>
  );
}

function LoadingTimelineItem() {
  return (
    <TimelineItem>
      <Row>
        <Skeleton width={24} height={24} margin="4px 0" />
        <Skeleton width={140} height={24} margin="4px 8px" padding={2} />
      </Row>
      <Skeleton
        height={18}
        width="70%"
        margin="32px 0 0"
        padding="0 0 0 40px"
      />
      <Skeleton height={22} margin="4px 0 8px" padding="0 0 0 40px" />
      <Skeleton
        height={18}
        width="30%"
        margin="0 0 24px"
        padding="0 0 0 40px"
      />
      <Row>
        <Skeleton width={24} height={24} margin="4px 0" />
        <Skeleton width={140} height={24} margin="4px 8px 16px" padding={2} />
      </Row>
    </TimelineItem>
  );
}

/** This is so this sits below the search results screen */
const LoadingWrapper = styled.div`
  background-color: ${color.white};
  z-index: 5;
  position: absolute;
  width: 100%;
  /* Make long enough that ads don't render within the visibility range */
  min-height: 200vh;
  overflow: hidden;
`;

const Header = styled.div`
  padding: ${spacing.xl};
  background-color: ${color.n20};
`;

const HeaderInner = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing.md};
`;

const TimelineItem = styled.div`
  padding: ${spacing.xl};
`;

const Row = styled.div`
  display: flex;
`;
